export default function isInternalLink(href) {
  if (typeof href !== "string" || !href.trim()) return false

  const link = href.trim()

  // Relative paths, fragments, and query strings stay within the site.
  if (!/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(link)) return true

  // Use the same origin during SSR and hydration, including on preview hosts.
  try {
    const siteUrl = new URL(process.env.NEXT_PUBLIC_SITE_URL)
    const url = new URL(link, siteUrl)

    return (url.protocol === "http:" || url.protocol === "https:") && url.origin === siteUrl.origin
  } catch {
    return false
  }
}
